import type { SVGProps } from "react";
export interface ClockIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ClockIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ClockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.876 18.145.875 12 5.857.875 12.001.875s11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M10.876 8.5a1.125 1.125 0 0 1 2.25 0v3.034l1.67 1.671.077.085a1.126 1.126 0 0 1-1.582 1.582l-.086-.076-2-2.001a1.13 1.13 0 0 1-.33-.796V8.5Z"
      />
    </svg>
  );
}
